import {
  pageViewSrc10Evid5000,
  ggGeneralActionSrc10Evid5001,
  ggCreateAiStoreFinishFlowSrc10Evid5003,
  ggAiStoreCreateMetasiteWithAppsSrc10Evid5004,
} from '@wix/bi-logger-stores-data/v2';
import {
  pageViewSrc10Evid5000Params,
  ggGeneralActionSrc10Evid5001Params,
  ggCreateAiStoreFinishFlowSrc10Evid5003Params,
  ggAiStoreCreateMetasiteWithAppsSrc10Evid5004Params,
} from '@wix/bi-logger-stores-data/v2/types';
import { ReportProps } from '@wix/web-bi-logger/dist/src/types';
import { BI_CONSTANTS, ActionClickedParams, getScreenNameFromStepId } from './biConstants';
import { useAppStore } from '../../stores/appStore';
import { getReferralInfo } from '../../utils/url';
import { getSubId } from '../../config/client';
import { getSubIdConfig } from '../../config/providers';

const { FLOWS } = BI_CONSTANTS;

type BiLoggerInstance = {
  report: (payload: ReportProps) => void | Promise<void>;
};

class BiLogger {
  private biLoggerInstance: BiLoggerInstance | null = null;

  initialize(biLogger: BiLoggerInstance) {
    this.biLoggerInstance = biLogger;
  }

  private report(payload: ReportProps) {
    if (!this.biLoggerInstance) {
      console.debug(`bi report ${payload.src}:${payload.evid}`, payload.params);
      return;
    }
    return this.biLoggerInstance.report(payload);
  }

  private getBaseAppContextFields() {
    const state = useAppStore.getState();
    const referral_info = getReferralInfo();
    return {
      referral_info: referral_info || undefined,
      flow: FLOWS.DS,
      profileId: state.sessionId || undefined,
    };
  }

  private getAppContextFields() {
    const state = useAppStore.getState();
    const screenName = getScreenNameFromStepId(state.currentStepId);
    return {
      ...this.getBaseAppContextFields(),
      screenName,
    };
  }

  pageView(pageName: string) {
    const state = useAppStore.getState();
    const referral_info = getReferralInfo();
    const params: pageViewSrc10Evid5000Params = {
      pageName,
      referral_info: referral_info || undefined,
      flow: FLOWS.DS,
      msId: state.msId || undefined,
      sub_id: getSubIdConfig() ? getSubId() : undefined,
    };

    void this.report(pageViewSrc10Evid5000(params));
  }

  actionClicked(actionClickedParams: ActionClickedParams) {
    const params: ggGeneralActionSrc10Evid5001Params = {
      ...actionClickedParams,
      ...this.getAppContextFields(),
    };
    void this.report(ggGeneralActionSrc10Evid5001(params));
  }

  generateSite(target_url: string) {
    const reportParams: ggCreateAiStoreFinishFlowSrc10Evid5003Params = {
      target_url,
      ...this.getBaseAppContextFields(),
    };
    void this.report(ggCreateAiStoreFinishFlowSrc10Evid5003(reportParams));
  }

  createMetasiteWithApps(msid: string, duration: number) {
    const params: ggAiStoreCreateMetasiteWithAppsSrc10Evid5004Params = {
      flow: FLOWS.DS,
      msid,
      duration,
    };
    void this.report(ggAiStoreCreateMetasiteWithAppsSrc10Evid5004(params));
  }
}

export const biLogger = new BiLogger();
